import { BaseFactory } from 'src/services/entity-factory/FactoryInterface';
import Testimonial from 'src/entities/Testimonial';

export interface ApiTestimonialResponse {
  testimonial: {
    id: number;
    name: string;
    title: string;
    message: string;
    image: string;
  };
}

export class TestimonialFactory extends BaseFactory<Testimonial> {
  public toEntity(args: ApiTestimonialResponse): Testimonial {
    return new Testimonial({
      id: args.testimonial.id,
      name: args.testimonial.name,
      title: args.testimonial.title,
      message: args.testimonial.message,
      image: args.testimonial.image,
    });
  }
}


// WEBPACK FOOTER //
// ./src/services/entity-factory/factories/TestimonialFactory.tsx